import { render, staticRenderFns } from "./UnidadesMedidasComponent.vue?vue&type=template&id=37d9158d&"
import script from "./UnidadesMedidasComponent.vue?vue&type=script&lang=js&"
export * from "./UnidadesMedidasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports